export enum WebPushElasticEvent {
    RegisterUrbanAirship = 'register-urban-airship',
    RegisterServiceWorker = 'register-service-worker',
}

export const WebPushRejectionReason = {
    NotificationDenied: {
        code: 1,
        reason: 'Notification not permitted.',
    },
    CannotRegister: {
        code: 2,
        reason: 'Push SDK cannot be registered.',
    },
    UncaughtExceptionDuringRegistration: {
        code: 3,
        reason: 'Uncaught exception while registering Push SDK.',
    },
    UAPromiseRejection: {
        code: 4,
        reason: 'Urban Airship thrown an error.',
    },
};
